<template>
  <div class="animated fadeIn col-md-12">
    <LoadingSpinner :loading="isLoading" />
    <b-row v-if="!isLoading">
      <b-col cols="12" md="12">
        <ul v-if="items.length" class="responsive-table m-0 p-0">
          <li class="table-header">
            <div
              :class="`col col-${dynamicCols(field)} `"
              v-for="(field, key) in fields"
              :key="key"
            >
              {{ field.label }}
            </div>
          </li>
          <li
            :class="`table-row ${
              item.enable ? `cursor-pointer` : `cursor-noDrop`
            }`"
            v-for="(item, key) in items"
            :key="key"
            @click="changeRoute(item)"
          >
            <div class="col col-1" v-if="item.requirement">
              <div class="circle-inside" :style="changeRowColor(item)">
                {{ key + 1 }}
              </div>
            </div>
            <div :class="`col col-6 ${item.enable ? `opcity-2` : `opcity-1`}`">
              <b>{{ item.name }}</b>
            </div>
            <div :class="`col col-2 ${item.enable ? `opcity-2` : `opcity-1`}`">
              <span
                class="fs-1"
                v-if="item.message && item.message.key !== `has_requirement`"
                >{{ item.message && item.message.fa }}</span
              >
              <div
                v-if="item.requirement && item.message.key == `has_requirement`"
              >
                <span v-if="item.requirement.code">{{
                  $lang.requirementTask.replace("{0}", key)
                }}</span>
              </div>
            </div>
            <div :class="`col col-1 d-none`">
              <i
                v-if="item.status && item.status.id == 1"
                :class="`fa fa-check fa-lg text-success ${
                  item.enable ? `opcity-2` : `opcity-1`
                }`"
                aria-hidden="true"
              ></i>
              <i
                v-if="!item.enable && item.status.id !== 1"
                :class="`fa fa-lock fa-lg text-danger ${
                  item.enable ? `opcity-2` : `opcity-2`
                }`"
                aria-hidden="true"
              ></i>
            </div>
          </li>
        </ul>
      </b-col>
      <b-col cols="12" md="12">
        <b-alert :show="!items.length" variant="info">
          <mdicon name="information" size="20" class="mr-1" />
          <strong v-html="$lang.emptyCartable" />
        </b-alert>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr } from "ramda";
import { checkActiveParvandeh, goToRoute } from "@/shared/utils";

export default {
  components: { LoadingSpinner },
  data() {
    return {
      activeParvandehData: {},
      fields: [],
      items: [],
      isLoading: false,
      allowFields: this.$lang.taskUser,
      setInterval: null,
      count: 0,
    };
  },
  computed: {
    parvandehCode() {
      return pathOr(null, ["code"], this.activeParvandehData);
    },
  },
  created() {
    this.fetchData();
  },
  destroyed() {
    clearInterval(this.setInterval);
  },
  methods: {
    pathOr,
    checkActiveParvandeh,
    dynamicCols(item) {
      switch (item.key) {
        case "id":
          return "1";
        case "name":
          return "6";
        case "show_at":
          return "2";
        case "message":
          return "2";
        case "status":
          return "1 d-none";
        default:
          return "1";
      }
    },
    changeRowColor(item) {
      let background_color = item.background_color
        ? `background-color:${item.background_color};`
        : ``;
      return `${background_color};`;
    },
    changeRoute(item) {
      if (item.enable) {
        const itemStatusId = pathOr(null, ["status", "id"], item);
        const actions = pathOr(null, ["decoded_actions"], item);

        const actionsName = pathOr(null, ["name"], actions);
        const actionsType = pathOr(null, ["type"], actions);
        const actionsParams = pathOr(null, ["params"], actions);
        const actionAddress = pathOr(null, ["params", "address"], actions);
        const termStateCode = this.termStateCode();

        if (
          itemStatusId !== 1 &&
          actionsName === "exam_pack" &&
          actionsType === "external_page" &&
          actionsParams
        ) {
          if (actionAddress) {
            const currentUrl = window.location.href;
            const link = `${actionAddress}?referrer=${currentUrl}`;
            return window.open(link, "_self");
          }
          if (!actionAddress && !termStateCode) {
            return goToRoute(actionsName, actionsParams, {}, false);
          }
          if (!actionAddress && termStateCode) {
            return goToRoute(actionsName, { termStateCode }, {}, false);
          }
        } else {
          goToRoute("showUserTask", { id: item.code }, {}, false);
        }
      }
    },
    changeDateStyle(time) {
      if (time) {
        let splice = time.split(" ");
        let splitTime = splice[1].split(":");
        return `<span>${splice[0]}</span><br/><b class='font-time'>${splitTime[0]}:${splitTime[1]}</b>`;
      }
    },
    loadItems() {
      this.setInterval = setInterval(() => {
        this.getItems();
      }, 60000);
    },
    async getItems() {
      this.activeParvandehData = { ...checkActiveParvandeh() };
      if (!this.parvandehCode) {
        return;
      }
      try {
        const url =
          this.$config.api_url +
          this.$config.resources.task +
          `?per_page=100&order_by=show_at:asc&parvandeh_code=${this.parvandehCode}`;
        const response = await this.$httpService.get(url);
        let newArray = response.data.data.result;

        this.items = newArray;
      } catch (error) {
        this.$generateError(error);
      }
    },
    async fetchData() {
      this.activeParvandehData = { ...checkActiveParvandeh() };
      if (!this.parvandehCode) {
        return;
      }
      try {
        this.isLoading = true;
        const url =
          this.$config.api_url +
          this.$config.resources.task +
          `?per_page=100&order_by=show_at:asc&parvandeh_code=${this.parvandehCode}`;
        const response = await this.$httpService.get(url);
        let data = response.data.data.result;
        if (data) this.items = data;
        if (Object.keys(this.allowFields).length !== 0) {
          this.fields = Object.keys(this.allowFields).map((item) => {
            return {
              label: this.allowFields[item],
              key: item,
              sortable: true,
              cols: 2,
            };
          });
        }
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    termStateCode(actions) {
      const actionName = pathOr(null, ["name"], actions);
      const payload =
        actionName === "payment" ? pathOr([], ["payload"], actions) : [];
      let code = null;
      for (const item of payload) {
        const term_state_code = pathOr(null, ["term_state_code"], item);
        if (term_state_code) {
          code = term_state_code;
          return;
        }
      }
      return code;
    },
  },
};
</script>
<style lang="scss">
.fs-1 {
  font-size: 1em;
}

.font-time {
  font-size: 1.1em;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-noDrop {
  cursor: no-drop;
}

.circle-inside {
  border-radius: 0 15px 15px 0;
  width: 42px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
  color: white;
}

.opcity-1 {
  opacity: 0.5;
}

.opcity-2 {
  opacity: 1;
}

.responsive-table {
  li {
    border-radius: 15px;
    padding: 5px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .table-header {
    background-color: #2889f1;
    color: white;
    font-size: 14px;
    padding: 15px;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  .table-header > div {
    display: flex;
    justify-content: normal;
    align-items: center;
  }

  .table-row {
    background-color: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.6);
    min-height: 50px;
  }

  .table-row > div {
    display: flex;
    justify-content: normal;
    align-items: center;
  }

  .col-1 {
    flex-basis: 10%;
  }

  .col-2 {
    flex-basis: 40%;
  }

  .col-3 {
    flex-basis: 25%;
  }

  .col-4 {
    flex-basis: 25%;
  }

  @media all and (max-width: 767px) {
    .table-row {
    }

    .col {
      flex-basis: 100%;
    }

    .col {
      display: flex;
      padding: 10px 0;

      &:before {
        color: #6c7a89;
        padding-right: 10px;
        content: attr(data-label);
        flex-basis: 50%;
        text-align: right;
      }
    }
  }
}
</style>
